"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { GoogleDriveConnectionStatus } from "./types";

/**
 * useGoogleDriveStatus
 *
 * Google Drive connection status for the current workspace. Gated on
 * workspaceId so the request never fires with an empty one (the backend
 * rejects that with a 400).
 */
export function useGoogleDriveStatus(workspaceId: string | undefined) {
  const safeId = workspaceId ?? "";

  const { data, isLoading, isError, refetch } =
    useApiGet<GoogleDriveConnectionStatus>(
      integrationKeys.googleDrive(safeId),
      `/api/google-drive/status?workspaceId=${encodeURIComponent(safeId)}`,
      undefined,
      {
        enabled: !!safeId,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    );

  return {
    connected: data?.connected ?? false,
    userEmail: data?.userEmail,
    isLoading,
    isError,
    refetch,
  };
}
